import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'htmltransfrom'
})
export class HtmlTransformPipe implements PipeTransform {

    transform(text: any): string {
        text = ['string', 'number'].includes(typeof text) ? text + '' : '';
        return text.replace(/</g, '<span><</span>');
    }
}
